import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { getHistory } from '../utils/history';
import { loadState, saveState } from '../utils/localStorage';
import { getProgressionLevels, getLevelLabel } from '../utils/progression';
import { useNavigate } from 'react-router-dom';

function getRecentHistory(days = 14) {
  const history = getHistory();
  const today = new Date();
  const data = [];

  const repsByDate = {};
  for (let j = 0; j < history.length; j++) {
    const h = history[j];
    repsByDate[h.date] = (repsByDate[h.date] || 0) + h.reps;
  }

  for (let i = days - 1; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(today.getDate() - i);
    const dateStr = d.toISOString().slice(0, 10);
    const reps = repsByDate[dateStr] || 0;
    data.push({ date: dateStr.slice(5), reps });
  }
  return data;
}

const GraphView = () => {
  const { t } = useTranslation();
  const state = loadState();
  const levels = getProgressionLevels();
  const currentLevel = (state && state.userProgress && typeof state.userProgress.currentLevelIndex === 'number') ? state.userProgress.currentLevelIndex : 0;
  const navigate = useNavigate();
  const data = getRecentHistory();

  const handleLevelChange = (delta) => {
    const idx = Math.max(0, Math.min(99, currentLevel + delta));
    if (idx !== currentLevel) {
      const newState = {
        ...state,
        userProgress: {
          ...(state && state.userProgress ? state.userProgress : {}),
          currentLevelIndex: idx,
          currentSetIndex: 0
        }
      };
      saveState(newState);
      window.location.reload();
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#fbeff3', fontFamily: 'Inter, Roboto, Segoe UI, Arial, sans-serif', color: '#333', paddingBottom: 60 }}>
      <div className="pretty-section">
        <h2 className="pretty-title">{t('graph')} <span className="pretty-sub">(Last 14 Days)</span></h2>
        <div style={{ width: '100%', height: 240, marginBottom: 24 }}>
          <ResponsiveContainer width="95%" height="100%">
            <BarChart data={data} margin={{ top: 10, right: 10, left: 10, bottom: 10 }}>
              <XAxis dataKey="date" />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="reps" fill="#f7a8c7" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div style={{ margin: '1.5rem 0' }}>
          <div>{t('current_level')}: <b>{levels[currentLevel]?.name}</b> ({getLevelLabel(currentLevel)})</div>
          <div>Sets: {levels[currentLevel]?.reps?.join('-')}</div>
          <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <span>{t('level_x', { level: '' })}:</span>
            <button
              className="pretty-btn"
              style={{ width: '40px', padding: '0.4rem', background: currentLevel <= 0 ? '#ccc' : undefined }}
              onClick={() => handleLevelChange(-1)}
              disabled={currentLevel <= 0}
            >
              -
            </button>
            <span style={{ fontWeight: 'bold', width: '30px', textAlign: 'center' }}>{currentLevel + 1}</span>
            <button
              className="pretty-btn"
              style={{ width: '40px', padding: '0.4rem', background: currentLevel >= 99 ? '#ccc' : undefined }}
              onClick={() => handleLevelChange(1)}
              disabled={currentLevel >= 99}
            >
              +
            </button>
          </div>
        </div>
        <button className="pretty-btn" onClick={() => navigate('/workout')}>{t('start_workout')}</button>
      </div>
    </div>
  );
};

export default GraphView;